import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type GetCouncilBoundaryImageRequest = {
  west: number;
  south: number;
  east: number;
  north: number;
  width: number;
  height: number;
};

export type GetCouncilBoundaryImageResponse = {
  base64: string; // Updated to match C# property name
  type: string;
  rect: string[];
};

export const getCouncilBoundaryImage = async (request: GetCouncilBoundaryImageRequest): Promise<GetCouncilBoundaryImageResponse | undefined> => {
  const response = await executeApiRequest(
    () =>
      axios.get<GetCouncilBoundaryImageResponse>(`/map/CouncilBoundaryImage`, {
        params: request,
        withCredentials: true
      }),
    false
  );

  return response?.data;
};
